module.exports = __webpack_public_path__ + "img/jh_logo.b147bf2a.png";